import { render, staticRenderFns } from "./marketing_message.vue?vue&type=template&id=579f8958&scoped=true&"
import script from "./marketing_message.vue?vue&type=script&lang=js&"
export * from "./marketing_message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579f8958",
  null
  
)

export default component.exports